import { render, staticRenderFns } from "./FunctionalAssessment.vue?vue&type=template&id=ef13db3c&scoped=true"
import script from "./FunctionalAssessment.vue?vue&type=script&lang=ts"
export * from "./FunctionalAssessment.vue?vue&type=script&lang=ts"
import style0 from "./FunctionalAssessment.vue?vue&type=style&index=0&id=ef13db3c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef13db3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef13db3c')) {
      api.createRecord('ef13db3c', component.options)
    } else {
      api.reload('ef13db3c', component.options)
    }
    module.hot.accept("./FunctionalAssessment.vue?vue&type=template&id=ef13db3c&scoped=true", function () {
      api.rerender('ef13db3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/ClientRightSide/FunctionalAssessment.vue"
export default component.exports